<template>
  <div class="container-fluid">
    <h2 class="title-1">И-баримт илгээх</h2>
    <div class="card w-100 mt-3">
      <div
        class="card-body"
      >PosAPI-д цугласан баримтыг гараар илгээх бол доорх товчийг дарна уу. Batch-тай давхацвал илгээхгүй болохыг анхаарна уу.</div>
      <div class="card-footer">
        <button @click="ebarimtSend" class="btn btn-success">Илгээх</button>
      </div>
    </div>
    <div v-if="failedDataCount > 0" class="card w-100 mt-3">
      <div
        class="card-body"
      >PosAPI-руу илгээхэд алдаа гарсан {{ failedDataCount }} transaction байна. "Дахин илгээх" товчийг дарж дахин илгээнэ үү. Batch-тай давхацвал илгээхгүй болохыг анхаарна уу.</div>
      <div class="card-footer">
        <button @click="ebarimtResend" class="btn btn-success">Дахин илгээх</button>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<script>
import OtherService from "@/services/OtherService";

export default {
  name: "SendEbarimt",

  data() {
    return {
      failedDataCount: 0
    };
  },

  created() {
    this.$store.dispatch("setLoading", true);
    OtherService.failedDataCount().then(response => {
      if (response.status == 200 && response.data.success == true) {
        if (response.data.payload > 0)
          this.failedDataCount = response.data.payload;
      }
      this.$store.dispatch("setLoading", false);
    });
  },

  methods: {
    ebarimtSend() {
      this.$store.dispatch("setLoading", true);
      OtherService.ebarimtSend().then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.$modal.show("dialog", {
            text: response.data.payload.toast,
            buttons: [
              {
                title: "Хаах"
              }
            ]
          });
        }
        this.$store.dispatch("setLoading", false);
      });
    },

    ebarimtResend() {
      this.$store.dispatch("setLoading", true);
      OtherService.executeFailedData().then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.$modal.show("dialog", {
            text: response.data.payload.toast,
            buttons: [
              {
                title: "Хаах"
              }
            ]
          });
        }
        this.$store.dispatch("setLoading", false);
      });
    }
  }
};
</script>